import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { of, Observable } from 'rxjs';
import { BaseComponent } from '../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppCacheService } from '../services/cache/app-cache.service';
import { AppConfigService } from '../services/init/app-config.service';

@Injectable()
export class MobileDeviceGuard extends BaseComponent implements CanActivate {
  constructor(deviceDetectorService: DeviceDetectorService, private cache: AppCacheService,  private appConfig: AppConfigService) {
    super(deviceDetectorService, cache, appConfig)
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isMobileDevice();
  }
}
